import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import slugify from '../../util/slugify';
import Typography from '../Typography';

export interface OverviewLayoutSectionProps {
  title?: string;
  description?: string;
}

const OverviewLayoutSection: React.FC<OverviewLayoutSectionProps> = ({
  title,
  description,
  children,
}) => {
  const htmlId = React.useMemo(() => {
    if (title) return slugify(title);

    return uuidv4();
  }, [title]);

  return (
    <section className="ckp-overview-layout__section" id={htmlId}>
      {title && (
        <Typography variant="h2" as="h2" classNames="u-margin-bottom-xs">
          {title}
        </Typography>
      )}

      {description && <Typography>{description}</Typography>}

      <div className="ckp-overview-layout__section__content">{children}</div>
    </section>
  );
};

export default OverviewLayoutSection;
